var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_vm._v(" Just an example... "),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.clients))])])])}
var staticRenderFns = []

export { render, staticRenderFns }